<template>
  <div>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 110px 0px 110px',
      }"
    >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title style="color: #395da5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-6"
                    :to="{
                      name: 'survey',
                    }"
                    @click="
                      $router.push({
                        name: 'survey',
                      })
                    "
                    >keyboard_double_arrow_left</v-icon
                  >
                </template>
                <span>กลับหน้าแรก</span>
              </v-tooltip>
              {{ $route.params.surveyName }}
            </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-data-table
        :headers="headers"
        :items="storePermission"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Permission</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <AddPermission v-if="AccPermission.createRole" />
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row no-gutters>
            <v-col cols="5"
              ><EditPermission v-if="AccPermission.update" :permission="item"
            /></v-col>
            <v-col cols="5"
              ><v-btn
                v-if="AccPermission.delete"
                color="#DE4F3B"
                icon
                @click="DeletePermision(item.role, item.roleID)"
                ><v-icon>delete</v-icon></v-btn
              ></v-col
            >
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import AddPermission from "./AddPermission.vue";
import EditPermission from "./EditPermission.vue";
export default {
  components: {
    AddPermission,
    EditPermission,
  },
  created() {
    this.$store.state.permissionlist = [];
    this.$store.dispatch("CheckPermission").then((resp_role) => {
      if (resp_role.data.permission) {
        if (Object.keys(resp_role.data.permission).length !== 0) {
          this.$store.commit("UpdateUserPermission", resp_role.data);
          if (resp_role.data.permission.account.view) {
            this.$store.dispatch("getPermission");
          } else {
            Swal.fire({
              icon: "error",
              text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
              title: "",
            }).then(() => {
              this.$router.push({
                name: "question",
              });
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
            title: "",
          }).then(() => {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            this.$router.push({
              name: "question",
            });
          });
        }
      }
    });
  },
  data() {
    return {
      headers: [
        { text: "role", value: "role", width: "40%" },
        { text: "serviceName", value: "serviceName", width: "40%" },
        { text: "", value: "actions", width: "20%" },
      ],
    };
  },
  computed: {
    storePermission() {
      let permission_filter = this.$store.state.permissionlist.filter(
        (role) => role.role !== "Member"
      );
      return permission_filter;
    },
    AccPermission() {
      return this.$store.state.user_permission.account;
    },
  },
  methods: {
    DeletePermision(role, roleID) {
      Swal.fire({
        title: `ยืนยันการลบ "${role}"`,
        text: "",
        icon: "warning",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("DeletePermission", {
              roleID: roleID,
              surveyID: this.$route.params.surveyID,
            })
            .then(() => {
              Swal.fire({
                icon: "success",
                text: "แก้ไขเรียบร้อยแล้ว",
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$store.dispatch("getPermission");
                this.validclose();
              });
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                icon: "error",
                text:
                  error.data.message === "Permission Denied"
                    ? "คุณไม่มีสิทธิ์เข้าถึงการลบ"
                    : "ไม่สามารถลบได้",
                title: "",
              }).then(() => {
                this.$store.commit("ToggleButtonLoading");
                this.$store.commit("ToggleLoading");
                if (error.data.message === "Permission Denied") {
                  this.$store
                    .dispatch(
                      "getQuestionPermission",
                      this.$route.params.surveyID
                    )
                    .then(() => {
                      this.$router.push({
                        name: "question",
                      });
                    });
                }
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
